// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  admin_api: 'https://admin.dinami.ec/api',
  // admin_api: 'http://localhost:8010/api',
  // factelec_api: 'http://localhost:8080/api',
  factelec_api: 'https://beta.dinami.ec:8888/api',
  uploadfile_api: 'http://localhost:3300/api'
};



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/environments/environment.ts